import React from 'react'

import { Box, DisplayPosition, Image, Overflow } from '@gousto-internal/citrus-react'

import { useDeviceType, DeviceType } from '@library/dom'

import effortless640jpg from '../../../assets/EffortlessHomeCookingSection/effortless-640px.jpg'
import effortless640webp from '../../../assets/EffortlessHomeCookingSection/effortless-640px.webp'
import effortless768jpg from '../../../assets/EffortlessHomeCookingSection/effortless-768px.jpg'
import effortless768webp from '../../../assets/EffortlessHomeCookingSection/effortless-768px.webp'
import effortless1024jpg from '../../../assets/EffortlessHomeCookingSection/effortless-1024px.jpg'
import effortless1024webp from '../../../assets/EffortlessHomeCookingSection/effortless-1024px.webp'

export function Background() {
  const deviceType = useDeviceType()

  let fallbackImg = effortless640jpg
  let img = effortless640webp

  if (deviceType === DeviceType.TABLET) {
    fallbackImg = effortless768jpg
    img = effortless768webp
  }

  if (deviceType === DeviceType.DESKTOP) {
    fallbackImg = effortless1024jpg
    img = effortless1024webp
  }

  return (
    <Box overflowX={Overflow.Hidden} position={DisplayPosition.Relative} height="450px">
      <Box
        bottom="0"
        left={['-145px', null, null, '0']}
        position={DisplayPosition.Absolute}
        right="0"
        top="0"
      >
        <Image
          alt="Chicken chow mein bowl"
          fit="cover"
          src={fallbackImg}
          srcSet={img}
          width={['640px', '90%', '83%', '100%']}
        />
      </Box>
    </Box>
  )
}
